var e=function(e){return function(r){if(r.theme&&r.theme.radius&&e)return"border-radius:".concat(r.theme.radius[e],";")}};export{e as default};
